import { ErrataNotaComplementarJustificativaEnum } from 'graphql/types.generated'

export enum TipoErrataNotaComplementarEnum {
  ERRATA = 'ERRATA',
  NOTA_COMPLEMENTAR = 'NOTA_COMPLEMENTAR',
}

export const tipoErrataNotaComplementarRecord: Record<TipoErrataNotaComplementarEnum, string> = {
  [TipoErrataNotaComplementarEnum.ERRATA]: 'Errata',
  [TipoErrataNotaComplementarEnum.NOTA_COMPLEMENTAR]: 'Nota complementar',
}

export const justificativaErrataNotaComplementarRecord: Record<ErrataNotaComplementarJustificativaEnum, string> = {
  [ErrataNotaComplementarJustificativaEnum.INFORMACAO_INCORRETA_ERRO_PREENCHIMENTO]:
    'Informação incorreta/erro de preenchimento',
  [ErrataNotaComplementarJustificativaEnum.REGISTRO_PACIENTE_INCORRETO]: 'Registro realizado em paciente incorreto',
  [ErrataNotaComplementarJustificativaEnum.INFORMACAO_INCOMPLETA]: 'Informação incompleta',
  [ErrataNotaComplementarJustificativaEnum.INFORMACAO_DESATUALIZADA]: 'Informação desatualizada',
  [ErrataNotaComplementarJustificativaEnum.OUTRO]: 'Outro',
}

export const justificativasPorTipoErrataNotaComplementarRecord: Record<
  TipoErrataNotaComplementarEnum,
  ErrataNotaComplementarJustificativaEnum[]
> = {
  [TipoErrataNotaComplementarEnum.ERRATA]: [
    ErrataNotaComplementarJustificativaEnum.INFORMACAO_INCORRETA_ERRO_PREENCHIMENTO,
    ErrataNotaComplementarJustificativaEnum.REGISTRO_PACIENTE_INCORRETO,
  ],
  [TipoErrataNotaComplementarEnum.NOTA_COMPLEMENTAR]: [
    ErrataNotaComplementarJustificativaEnum.INFORMACAO_INCOMPLETA,
    ErrataNotaComplementarJustificativaEnum.INFORMACAO_DESATUALIZADA,
    ErrataNotaComplementarJustificativaEnum.OUTRO,
  ],
}

export interface ErrataNotaComplementarModel {
  justificativa: ErrataNotaComplementarJustificativaEnum
  descricao: string
}
